import {
  OMITTED_SYSTEM_PERMISSIONS,
  SYSTEM_SUPERUSER_PERMISSION,
} from '@/common/constants/domains.constants';
import hasSystemTag from '@/common/utils/model.util';
import { USER_TYPE_TEXT, USER_TYPES } from '@/common/constants/users.constants';

/**
 * Map API DomainUser properties to store object with only usable attributes
 * @param attributes
 * @returns {{role, assignedProjects, systemPermissions, name, description, id, enabled, email, domainPermissions}}
 */
function domainUser(attributes) {
  if (!attributes?.id) {
    return null;
  }

  const {
    id,
    tags = [],
    name = null,
    enabled: isEnabled = false,
    email = null,
    description = null,
    role = null,
    domain_id: domainId = null,
    system_permissions: systemPermissions = [],
    domain_permissions: domainPermissions = [],
    assigned_projects: assignedProjects = [],
    identity_provider: identityProvider = null,
    created_at = null,
    s3_user_id = null,
    totp_status: totpStatus = null,
  } = attributes;

  const isFederated = !!identityProvider;
  const type = isFederated ? USER_TYPES.FEDERATED : USER_TYPES.LOCAL;
  const typeText = USER_TYPE_TEXT[type];

  return {
    id,
    name,
    isEnabled,
    email,
    description,
    domainId,
    role,
    tags,
    systemPermissions: systemPermissions?.filter(permission => OMITTED_SYSTEM_PERMISSIONS.indexOf(permission) === -1),
    domainPermissions,
    assignedProjects,
    isSystem: hasSystemTag(tags),
    isDefaultAdmin: systemPermissions?.indexOf(SYSTEM_SUPERUSER_PERMISSION) !== -1,
    type,
    typeText,
    isFederated,
    identityProvider,
    created_at,
    s3_user_id,
    totpStatus
  };
}

export default domainUser;
